module.exports = __webpack_public_path__ + "img/csr_banner_01_mobile.a93cf767.jpg";